<script>
export default {
    name: "StopAdministration",

    data() {

        return {
            memo: ``,
        };
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        patient: {
            type: Object,
            default: () => ({}),
        },
        prescription: {
            type: Object,
            default: () => ({}),
        },
    },

    methods: {

        saveStopAdministration() {
            if(!window.confirm(`Confirm Stop Administration`)) return;

            const stopAdmn = {
                prescriptionId: this.prescription.code,
                comment: this.memo,
                userName: this.$root.username,
            };

            this.$root.loading = true;
            this.$http.post(`MedicalFile/StopPatientDrugTreatment`, stopAdmn).then(({ data }) => {
                this.$emit(`refresh`);
                this.$root.loading = false;
                window.Swal.fire({ type: `success`, text: data, });
                this.$emit(`closeModal`);
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-1/2 w-full">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Stop Administration</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full flex flex-wrap bg-gray-300 p-1">
            <div class="flex-1 p-1">Name: {{ patient.names }}</div>
            <div class="flex-1 p-1">MRN: {{ patient.patienT_ID }}</div>
            <div class="flex-1 p-1">Drug: {{ prescription.drug }}</div>
        </div>
        <div class="w-full p-1 mt-2">
            <label for="grid-notes" class="label-control">Comment:</label>
            <textarea 
                v-model.trim="memo"
                id="grid-comment" rows="3" 
                class="input-control input-sm text-xs"></textarea>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
    <button class="btn-primary btn-sm text-xs rounded" 
        @click.prevent="saveStopAdministration">
            <i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>
